import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { NativeSelect, Box } from '@material-ui/core'
import * as directoryActions from 'actions/components/directory'
import { Merchant } from 'models/merchant'
import * as merchantConstants from 'constants/merchant'

class TimeslotSelector extends React.Component {
  constructor (props) {
    super(props)
    this.state = { }
  }

  handleTimeChange = (date) => {
    this.props.updateSelectedTime(date)
  }

  renderTimeslotOptions = () => {
    const { intl, timeslots, merchant, deliveryType, deliveryTime } = this.props
    const takeaway = deliveryType === merchantConstants.DELIVERY_TYPE_TAKEAWAY
    const storeDelivery = deliveryType === merchantConstants.DELIVERY_TYPE_STOREDELIVERY
    const immediateText0 = merchant.setting.defaultClientLanguage === 'en' ? 'Immediate' : intl.formatMessage({ id: 'directory.selector.immediate' })
    const immediateText45 = merchant.setting.defaultClientLanguage === 'en' ? 'Deliver in Around 45 min*' : intl.formatMessage({ id: 'directory.selector.around45minDeliver' })
    const pickupAfterText = merchant.setting.defaultClientLanguage === 'en'
      ? 'Pickup After ' + merchant.setting.takeawayPickupAfterMins + 'min*'
      : intl.formatMessage({ id: 'directory.selector.pickupAfter' }) + merchant.setting.takeawayPickupAfterMins + intl.formatMessage({ id: 'directory.selector.minPickup' })
    const takeawayTimeText = (merchant.setting.takeawayPickupAfterMins === 0 || merchant.setting.takeawayPickupAfterMins === null) ? immediateText0 : pickupAfterText

    const immediateText = takeaway
      ? takeawayTimeText
      : immediateText45
    const aroundText = merchant.setting.defaultClientLanguage === 'en' ? 'Deliver in Around' : intl.formatMessage({ id: 'directory.selector.around' })
    const minDeliver = merchant.setting.defaultClientLanguage === 'en' ? 'min*' : intl.formatMessage({ id: 'directory.selector.minDeliver' })

    const estimatedDeliveryTime = deliveryTime ? `${aroundText} ${deliveryTime} ${minDeliver}` : immediateText

    const availableTimeslots = _.clone(timeslots) || []
    const takeawayTime = (merchant.openingsWithSurcharge[moment().format('e')] || []).find(o => o.takeaway)

    // takeaway
    if (takeaway) {
      const timeslotOptions = availableTimeslots.map((timeslot, index) => {
        return (
          <option
            key={index + 1}
            value={moment(timeslot).toISOString()}>
            {
              index === 0 && moment().isSame(timeslot, 'day') && moment(takeawayTime.start + ':' + takeawayTime.startMin, 'HH:mm').isBefore(moment())
                ? immediateText
                : timeslot.format('HH:mm')
            }
          </option>
        )
      })
      return [...timeslotOptions]
    }

    // storeDelivery or shop
    const m = new Merchant(merchant)
    const isImmediateAvailable = !!m.getActiveOpening(
      moment().add(deliveryTime, 'minutes'),
      merchantConstants.DELIVERY_TYPE_STOREDELIVERY,
    )
    const immediateOption = (
      <option key='immediate' value={moment().add(deliveryTime, 'minutes').toISOString()}>
        {estimatedDeliveryTime}
      </option>
    )
    const timeslotOptions = availableTimeslots.map((timeslot, index) => {
      return (
        <option
          key={index}
          value={moment(timeslot).toISOString()}>
          {timeslot.format('HH:mm')}
        </option>
      )
    })

    // add immediateOption only is today.
    if (moment().isSame(availableTimeslots[0], 'day') && isImmediateAvailable) {
      // 移除第一個 timeslot 因為跟 immediateOption 重複
      timeslotOptions.shift()
      return [immediateOption, ...timeslotOptions]
    }

    return [timeslotOptions]
  }

  render () {
    const { classes, directory } = this.props

    return (
      <Box m='24px'>
        <NativeSelect
          fullWidth
          disableUnderline
          classes={{ root: classes.underline }}
          value={directory.selectedTime}
          onChange={e => this.handleTimeChange(e.target.value)}
        >
          {this.renderTimeslotOptions()}
        </NativeSelect>
      </Box>
    )
  }
}

const styles = {
  underline: {
    borderBottom: '2px solid #EBBD3F',
  },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
    basket: state.basket,
    directory: state.directory,
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(directoryActions, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  injectIntl,
)(TimeslotSelector)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Selector/TimeslotSelector.jsx